export class WebConsultaDocsFiltro {

    nrCpf: string;

    nome: string;

    dtIni: Date;

    dtFim: Date;

}
